import React from 'react';
import './video-page.scss'

export const VideoPage = () => {
    return (<div>
        <div className={'video__attention'}>
            <div>If the video doesn't play, please press the button.</div>
            <div>ビデオがさいせいされないときはボタンをおしてください。</div>
        </div>
    </div>)
};